import React from 'react';
import OrderCard from '../OrderCard/OrderCard';
import './OrderList.css';

function OrderList(props) {
  const {
    list,
  } = props;
  return (
    <section className="orders-container">
      {
        list.map((e) => <OrderCard order={e} key={e._id} />)
      }
    </section>
  );
};

export default OrderList;
